import { Link } from "wouter";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
          <div className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} TeamPulse®. All rights reserved.
          </div>
          <nav className="flex items-center gap-4 text-sm">
            <Link
              href="/blog"
              className="text-gray-500 hover:text-gray-900 transition-colors no-underline"
              data-testid="link-blog-footer"
            >
              Blog
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
